"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DifferentialPairAssertions = exports.DifferentialPairLegsSymmetric = exports.DifferentialPairEndpointConnected = exports.DifferentialPairRequirement = void 0;
const enums_1 = require("../enums");
const DIFFERENTIAL_PAIR_REQUIREMENT_ID = 'req_cadstromdiffpair00000000000000000000';
exports.DifferentialPairRequirement = {
    id: DIFFERENTIAL_PAIR_REQUIREMENT_ID,
    slug: 'cadstrom.diff_pair',
    slugPrefix: 'DIFF',
    name: 'Differential Pairs',
    description: 'Asserts that every interface differential pair endpoint connects to its partner with matching polarity, and that the two legs of each pair carry matching series parts.',
};
exports.DifferentialPairEndpointConnected = {
    id: 'asrt_diffpairendpointconnected00000000000',
    slug: 'cadstrom.diff_pair.endpoint_connected',
    requirementDefinitionId: DIFFERENTIAL_PAIR_REQUIREMENT_ID,
    name: 'Differential pair endpoint must connect to its partner with matching polarity',
    description: 'Both pins of a differential pair endpoint must connect, positive to positive and negative to negative, to the same partner endpoint, either directly or through one coupling capacitor, ferrite, or low-value resistor on each leg. A swapped, half-connected, or split pair corrupts the signal; an endpoint whose pins are both unconnected is unused and not applicable.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.DifferentialPairLegsSymmetric = {
    id: 'asrt_diffpairlegssymmetric000000000000000',
    slug: 'cadstrom.diff_pair.legs_symmetric',
    requirementDefinitionId: DIFFERENTIAL_PAIR_REQUIREMENT_ID,
    name: 'Differential pair legs must carry matching series parts',
    description: 'Where a differential pair passes through series parts such as AC-coupling capacitors, ferrites, or series resistors, both legs must carry the same kind of part with the same value. A part on one leg only, or a mismatched value, unbalances the pair and converts differential signal into common-mode noise.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.DifferentialPairAssertions = [
    exports.DifferentialPairEndpointConnected,
    exports.DifferentialPairLegsSymmetric,
];
//# sourceMappingURL=differential-pair.js.map